import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import LOGO from '../logo_b64';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // close menu on route change
  useEffect(() => { setMenuOpen(false); }, [location]);

  const scrollTo = (id) => {
    setMenuOpen(false);
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }), 120);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const NAV_ITEMS = [
    { label: 'About', id: 'about' },
    { label: 'Services', id: 'services' },
    { label: 'Contact', id: 'contact' },
  ];

  return (
    <>
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 200,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '16px 48px',
        background: scrolled || menuOpen ? 'rgba(4,8,15,0.92)' : 'transparent',
        backdropFilter: scrolled || menuOpen ? 'blur(16px)' : 'none',
        borderBottom: scrolled || menuOpen ? '1px solid rgba(255,255,255,0.06)' : 'none',
        transition: 'all 0.4s ease',
      }}>
        <Link to="/" style={{ zIndex: 201 }}>
          <img src={LOGO} alt="DOIT Creative" style={{ height: '32px', display: 'block' }} />
        </Link>

        {/* Desktop menu */}
        <ul style={{ listStyle: 'none', display: 'flex', gap: '36px', margin: 0, padding: 0 }}
          className="nav-desktop">
          {NAV_ITEMS.map(({ label, id }) => (
            <li key={id}>
              <button onClick={() => scrollTo(id)} style={{
                background: 'none', border: 'none', cursor: 'pointer',
                fontFamily: "'Mona Sans', sans-serif",
                fontSize: '13.5px', fontWeight: 400,
                color: 'rgba(240,240,248,0.55)',
                letterSpacing: '0.04em', transition: 'color 0.2s', padding: 0,
              }}
                onMouseEnter={e => e.target.style.color = '#f0f0f8'}
                onMouseLeave={e => e.target.style.color = 'rgba(240,240,248,0.55)'}
              >{label}</button>
            </li>
          ))}
        </ul>

        {/* Hamburger — mobile only */}
        <button
          className="nav-hamburger"
          onClick={() => setMenuOpen(o => !o)}
          style={{
            display: 'none', background: 'none', border: 'none',
            cursor: 'pointer', padding: '4px', zIndex: 201,
            flexDirection: 'column', gap: '5px',
          }}
          aria-label="Menu"
        >
          {[0, 1, 2].map(i => (
            <span key={i} style={{
              display: 'block', width: '22px', height: '1.5px',
              background: '#f0f0f8', borderRadius: '1px',
              transition: 'all 0.3s ease',
              transform: menuOpen
                ? i === 0 ? 'translateY(6.5px) rotate(45deg)'
                  : i === 2 ? 'translateY(-6.5px) rotate(-45deg)'
                  : 'scaleX(0)'
                : 'none',
            }} />
          ))}
        </button>
      </nav>

      {/* Mobile dropdown */}
      {menuOpen && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          zIndex: 199, background: 'rgba(4,8,15,0.97)',
          display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center', gap: '8px',
        }}>
          {NAV_ITEMS.map(({ label, id }) => (
            <button key={id} onClick={() => scrollTo(id)} style={{
              background: 'none', border: 'none', cursor: 'pointer',
              fontFamily: "'Mona Sans', sans-serif",
              fontSize: '32px', fontWeight: 800,
              color: 'rgba(240,240,248,0.7)',
              letterSpacing: '-0.02em', padding: '12px 0',
              transition: 'color 0.2s',
            }}
              onTouchStart={e => e.target.style.color = '#f0f0f8'}
              onTouchEnd={e => e.target.style.color = 'rgba(240,240,248,0.7)'}
            >{label}</button>
          ))}
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .nav-desktop { display: none !important; }
          .nav-hamburger { display: flex !important; }
        }
      `}</style>
    </>
  );
}
